import { render, staticRenderFns } from "./prospect_page.vue?vue&type=template&id=077497f2&"
import script from "./prospect_page.vue?vue&type=script&lang=js&"
export * from "./prospect_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports